/**
 * Bewertung einer Person für einen Bereich zu einem Zeitpunkt.
 *
 * Diese Funktion ist der Grund für das Paket: sie läuft unverändert auf dem
 * Server und auf dem Duty-Gerät. Zwei Fassungen würden auseinanderlaufen,
 * und dieselbe Person wäre offline GRÜN und online ROT.
 *
 * Die Reihenfolge der Prüfungen ist Absicht: eine gesperrte Karte bleibt
 * gesperrt, auch wenn zusätzlich der Bereich nicht passt. Die Duty-Kraft
 * soll den Grund sehen, der das Gespräch bestimmt.
 */
export function evaluatePerson(person, area, now) {
    if (person.status === 'revoked')
        return { result: 'red', reason: 'revoked' };
    if (person.status === 'expired')
        return { result: 'red', reason: 'expired' };
    const until = toDate(person.validUntil);
    if (until && until < now)
        return { result: 'red', reason: 'expired' };
    const from = toDate(person.validFrom);
    if (from && from > now)
        return { result: 'red', reason: 'not_yet_valid' };
    if (!person.areas.includes(area))
        return { result: 'red', reason: 'wrong_area' };
    return { result: 'green' };
}
function toDate(value) {
    if (!value)
        return null;
    return value instanceof Date ? value : new Date(value);
}
